import { render, staticRenderFns } from "./defaultImg.vue?vue&type=template&id=3220679d&scoped=true&"
import script from "./defaultImg.vue?vue&type=script&lang=js&"
export * from "./defaultImg.vue?vue&type=script&lang=js&"
import style0 from "./defaultImg.vue?vue&type=style&index=0&id=3220679d&prod&lang=less&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3220679d",
  null
  
)

export default component.exports